import * as ST from './styled';

export type DescribedListItemProps = {
    title: string,
    value: string | number,
    imagePath: string,
};

export const DescribedListItem = (
    {
        title,
        value,
        imagePath,
        ...rest
    }: DescribedListItemProps,
): JSX.Element => {
    return (
        <ST.DescribedListItem {...rest}>
            <ST.Image src={imagePath} width={24} height={24} alt={title} />
            <ST.Title>{title}</ST.Title>
            <ST.Text>{value}</ST.Text>
        </ST.DescribedListItem>
    );
};
